module.exports = __webpack_public_path__ + "img/7be553a.svg";